import { useState } from "react";

export const useJustificationAbsences = () => {  
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [openModalError, setOpenModalError] = useState(false);
  const [messageModalMessage, setMessageModalMessage] = useState("");
  const [messageModalError, setMessageModalError] = useState("");
  const [openModalMessage, setOpenModalMessage] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  //Tabs
  const cleanAll = () => {
    setLoading(false);
    setLoadingModal(false);
    setOpenModalError(false);
    setOpenModalMessage(false);
    setMessageModalError("");
    setMessageModalMessage("");
    setCurrentPage(1);
  };

  const onChangeTab = (value: number) => {
    cleanAll();
    setCurrentPage(value);
  };
  
  return {
    loading,
    loadingModal,
    openModalError,
    messageModalError,
    setOpenModalError,
    openModalMessage,
    setOpenModalMessage,
    messageModalMessage,
    setLoading,
    setMessageModalError,
    setMessageModalMessage,
    setLoadingModal,
    onChangeTab,
    currentPage
  };
}